import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';
interface RecommendHometownNewsVerticalCardProps {
  className?: string;
  daysAgo: string;
  idIdx: string;
  name: string;
  thumbnail: string;
}
export const RecommendHometownNewsVerticalCard = t0 => {
  const $ = _c(20);
  const {
    className,
    daysAgo,
    idIdx,
    name,
    thumbnail
  } = t0;
  let t1;
  if ($[0] !== idIdx || $[1] !== name) {
    t1 = ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
      idIdx: buildDetailSlug(idIdx, name)
    });
    $[0] = idIdx;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const routePathname = t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn("flex h-244 w-161 flex-col gap-10", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name || $[6] !== thumbnail) {
    t3 = <Image alt={name} className="size-160 rounded-small border border-Gray-300 object-cover" height={160} src={thumbnail} width={160} />;
    $[5] = name;
    $[6] = thumbnail;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== name) {
    t4 = <h4 className="line-clamp-2 text-ellipsis break-all font-500 text-Gray-900 typo-body3">{name}</h4>;
    $[8] = name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== daysAgo) {
    t5 = <p className="font-400 text-Gray-600 typo-caption1">{daysAgo}</p>;
    $[10] = daysAgo;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <section className="flex h-73 flex-col justify-between gap-6">{t4}{t5}</section>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== routePathname || $[16] !== t2 || $[17] !== t3 || $[18] !== t6) {
    t7 = <CustomLink className={t2} href={routePathname}>{t3}{t6}</CustomLink>;
    $[15] = routePathname;
    $[16] = t2;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};